module.exports = __webpack_public_path__ + "img/10.fcf08d0a.webp";